import React from 'react'

import styles from "../styles/logpage.module.css"

export default () =>{
    return(
        <div className={styles.body}>
            <div className={styles.notFound}>
            <div className = {styles.title}>
        <p className= {styles.char}>Char<p className = {styles.dot}>.</p>ly</p>
      </div>
                <h1 className ={styles.titleText}>Account Not Found</h1>
                <p className = {styles.secondaryText}>You must be signed in to your account in order to access this content. </p>
                <a className = {styles.redirectButton} href="/signin">Sign in here</a>
                <p className = {styles.secondaryText}>or</p>
                <a className = {styles.redirectButton} href="/signup">Sign up here</a>
            </div>
        </div>
    )
}